import gsap from "gsap";

const linksAccordion = document.querySelectorAll("section.link-image-list");

linksAccordion.forEach((accordionSection) => {
  const desktopImage = accordionSection.querySelector("img.link-img");
  const accordionItems = accordionSection.querySelectorAll(".accordion-item");

  accordionItems.forEach((accordionItem) => {
    accordionItem.addEventListener("mouseenter", () => {
      if (accordionItem.classList.contains("active")) return;

      const imgUrl = accordionItem.dataset.img;

      // Swap desktop image only
      if (window.innerWidth >= 1024) {
        desktopImage.src = imgUrl;
        // gsap.to(desktopImage, {
        //   opacity: 0,
        //   duration: 0.25,
        //   ease: "power2.inOut",
        //   onComplete: () => {
        //     desktopImage.src = imgUrl;
        //     gsap.to(desktopImage, {
        //       opacity: 1,
        //       duration: 0.25,
        //       ease: "power2.inOut",
        //     });
        //   },
        // });
      }

      // Remove active from all, hide all mobile images
      accordionItems.forEach((item) => {
        item.classList.remove("active");
        const itemImage = item.querySelector(".item-image");
        if (itemImage) itemImage.classList.add("hidden");
      });

      // Add active to current, show mobile image
      accordionItem.classList.add("active");
      const currentImage = accordionItem.querySelector(".item-image");
      if (currentImage) currentImage.classList.remove("hidden");
    });
  });
  const firstItem = accordionItems[0];
  const firstItemImage = firstItem?.querySelector(".item-image");

  if (window.innerWidth < 1024 && firstItemImage) {
    firstItemImage.classList.remove("hidden");
  }
});
